import { Observable } from 'rxjs';
import { SelfDiagnosisModel, SelfDiagnosisStepRateModel } from '../../../store/self-diagnostic/self-diagnosis/model';
import { InteractorResponse } from '../../models/interactor-response';

export abstract class AbstractSelfDiagnosisApiService {
  public abstract getAll(): Observable<InteractorResponse<SelfDiagnosisModel[]>>;
  public abstract getById(id: number): Observable<InteractorResponse<SelfDiagnosisModel>>;
  public abstract update(entity: SelfDiagnosisModel): Observable<InteractorResponse<SelfDiagnosisModel>>;
  public abstract delete(id: number): Observable<InteractorResponse<SelfDiagnosisModel>>;
  public abstract setStepRate(entity: SelfDiagnosisStepRateModel): Observable<InteractorResponse<SelfDiagnosisStepRateModel>>;
  public abstract uploadIcon(entity: SelfDiagnosisModel, file: File): Observable<InteractorResponse<SelfDiagnosisModel>>;
  public abstract deleteIcon(entity: SelfDiagnosisModel): Observable<InteractorResponse<SelfDiagnosisModel>>;
}
